// 서비스 접수 상태 설정
// 리뉴얼/이전 등으로 세탁 접수를 일시 중단할 때 사용합니다.
//
// 접수를 다시 받으려면 아래 ORDERS_OPEN 값을 true 로만 변경하면
// 모든 "세탁 신청" 버튼이 원래대로 신청 폼으로 연결됩니다.
export const ORDERS_OPEN = false;

// 접수 중단 시 노출되는 안내 문구
export const SERVICE_CLOSED_NOTICE = {
  title: '서비스 리뉴얼 중입니다',
  lines: [
    '현재 더 나은 품질의 서비스를 제공하기 위한 준비를 진행하고 있어 일시적으로 접수를 중단합니다.',
    '이용에 불편을 드려 죄송하며, 더욱 완성된 모습으로 다시 찾아뵙겠습니다.',
  ],
};
